function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = function (moderate) {
  var _moderate$tweets;
  var count = ((_moderate$tweets = moderate.tweets) === null || _moderate$tweets === void 0 ? void 0 : _moderate$tweets.length) || 0;
  if (!count) {
    return '';
  }
  var items = '';
  var _iterator = _createForOfIteratorHelper(moderate.tweets),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var tweet = _step.value;
      var tweetHtml = typeof tweet.renderHTML === 'function' ? tweet.renderHTML('tweet') : '';
      items += "\n      <div class=\"item\" data-id=\"".concat(tweet.signature, "\">\n        ").concat(tweetHtml, "\n        <div class=\"actions\">\n          <button type=\"button\" class=\"saito-button-secondary small\" data-action=\"approve\" data-id=\"").concat(tweet.signature, "\">\n            Approve Tweet\n          </button>\n          <button type=\"button\" class=\"saito-button-secondary small\" data-action=\"delete\" data-id=\"").concat(tweet.signature, "\">\n            Delete Tweet\n          </button>\n          <button type=\"button\" class=\"saito-button-secondary small\" data-action=\"ban\" data-id=\"").concat(tweet.signature, "\">\n            Ban User\n          </button>\n        </div>\n      </div>\n    ");
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return "\n    <section class=\"moderate\">\n      <div class=\"header\">\n        <span class=\"title\">Review Reports</span>\n        <span class=\"count\">".concat(count, "</span>\n      </div>\n      <div class=\"items\">\n        ").concat(items, "\n      </div>\n    </section>\n  ");
};